// @flow
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

type Options = {
    name: 'section' | 'module',
    tabs: Array<*>
};

type ActiveState = [number, (value: number) => void];

const useActiveState = ({ name, tabs }: Options): ActiveState => {
    const history = useHistory();
    const location = useLocation();

    const query = new URLSearchParams(location.search);
    const section = query.get(name);

    const activeTabIndex = React.useMemo(
        () => tabs.findIndex(({ id }) => id === section),
        [section, tabs]
    );

    const setSection = (value: number) => {
        query.set(name, tabs[value].id);

        // This is used to highlight the field based used for deeplinking in search.
        // So deleting setting once user changes the section or module since the
        // setting is not needed anymore.
        query.delete('setting');

        // 'module' is the vertical tab items comes under a tab (section). So deleting
        // this when user changes from tab to tab.
        if (name === 'section') {
            query.delete('module');
        }

        const search = query.toString();
        history.replace({ ...location, search });
    };

    // Set the default section for the initial load.
    if (activeTabIndex === -1) {
        setSection(0);
    }

    return [activeTabIndex === -1 ? 0 : activeTabIndex, setSection];
};

export default useActiveState;
